import { render } from "./LanguageSelectorModal.vue?vue&type=template&id=568ec0b4"
import script from "./LanguageSelectorModal.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__